import { useEffect, useState } from 'react';

interface componentData {
  Hour: number;
  Minute: number;
}

interface Props {
  _value: Partial<componentData>;
  onChange: (data: Partial<componentData>) => void;
  readonly?: boolean;
  _label?: string;
}

export const InputHours = ({ _value, onChange, readonly, _label }: Props) => {
  const [values, setValues] = useState<Partial<componentData>>({});

  useEffect(() => {
    if (_value) setValues(_value);
  }, [_value]);

  const handleChange = (field: keyof componentData, value: number) => {
    const newValues = { ...values, [field]: value };
    setValues(newValues);
    onChange(newValues);
  };

  return (
    <>
      <label>{_label ?? "Horas"}</label>
      <div className="row">
        <div className="col-md-6">
          <select
            disabled={readonly}
            className="form-select"
            value={values.Hour ?? ""}
            onChange={(e) => handleChange("Hour", parseInt(e.target.value))}
          >
            <option value="">HH</option>
            {[...Array(24)].map((_, i) => (
              <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
            ))}
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select"
            disabled={readonly}
            value={values.Minute ?? ""}
            onChange={(e) => handleChange("Minute", parseInt(e.target.value))}
          >
            <option value="">MM</option>
            {[...Array(60)].map((_, i) => (
              <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
};
